export default [
    {
        path: 'oferta/:tag/:id',
        name: 'OffersDetails',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/offer-details')
    },
    {
        path: 'proposta/:id',
        name: 'proposalDetails',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/offer-details')
    },
    {
        path: 'home',
        name: 'DashboardSupplier',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/dashboard/')
    },
    {
        path: 'pacotes-de-moedas',
        name: 'BalancePurchase',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/balance-purchase/')
    },
    {
        path: 'ofertas',
        name: 'CompetitionDashboard',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/competition-dashboard/CompetitionDashboard.vue')
    },
    {
        path: 'editar-perfil',
        name: 'EditProfileSupplier',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/signup/form/Form.vue')
    },
    {
        path: 'contatos',
        name: 'MyContacts',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/list-contacts')
    },
    {
        path: 'minhas-cotacoes',
        name: 'MyOpportunities',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/opportunities')
    },
    {
        path: 'checkout',
        name: 'Checkout',
        meta: { backgroundGrey: true, header: 'blank' },
        component: () => import('@/views/checkout')
    },
    {
        path: 'rede-de-contatos',
        name: 'ContactNetwork',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/contact-network')
    },
    {
        path: 'engelink-marketing/:id',
        name: 'ReservedForYou',
        meta: { backgroundGrey: true, isSupplier: true },
        component: () => import('@/views/supplier/offer-details')
    }
];
